import { render, staticRenderFns } from "./PH11V.vue?vue&type=template&id=040bfcfc&scoped=true"
import script from "./PH11V.vue?vue&type=script&lang=js"
export * from "./PH11V.vue?vue&type=script&lang=js"
import style0 from "./PH11V.vue?vue&type=style&index=0&id=040bfcfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040bfcfc",
  null
  
)

export default component.exports